export const CustomerStatus = [
    {
        name: "Bình thường",
        code: "NORMAL"
    },
    {
        name: "Đã giao",
        code: "ASSIGNED"
    },
    {
        name: "Đã chặn",
        code: "BLOCKED"
    },
    {
        name: "Chăm sóc",
        code: "TAKECARE"
    },
    {
        name: "Xác nhận",
        code: "APPROVED"
    },
    {
        name: "Đã đăng ký",
        code: "REGISTERED"
    },
]

export const SubscriberType = [
    {
        name: "Trả trước",
        code: "TRATRUOC"
    }, {
        name: "Trả sau",
        code: "TRASAU"
    },
]

export const RequestType = [
    {
        name: "Hoàn trước",
        code: "HOANTRUOC"
    }, {
        name: "Hoàn sau",
        code: "HOANSAU"
    },
    {
        name: "Không hoàn",
        code: "KHONGHOAN"
    },
    {
        name: "Hoàn thêm",
        code: "HOANTHEM"
    },
]

export const RequestMethodType = [
    {
        name: "Nâng cấp",
        code: "NANGCAP"
    }, {
        name: "Gia hạn",
        code: "GIAHAN"
    }
]


export const InvitationStatus = [
    {
        name: "Thành công",
        code: "SUCCESS"
    }, {
        name: "Thất bại",
        code: "FAILD"
    }
]

export const CustomerCareStatus = [
    {
        name: "",
        code: ""
    },
    {
        name: "Đồng ý",
        code: "APPROVED"
    },
    {
        name: "Không đồng ý",
        code: "REJECTED"
    },
    {
        name: "Hẹn lại",
        code: "APPOINTMENT"
    },
    {
        name: "Không bắt máy",
        code: "KBM"
    },
    {
        name: "Không liên lạc được",
        code: "KLLĐ"
    },
    {
        name: "Dùng lại gói cũ",
        code: "KEEP"
    },
    {
        name: "Đã đăng ký lại",
        code: "RE-REGISTER"
    },
    // {
    //     name: "Mời lại hôm sau",
    //     code: "MOI_LAI_HOM_SAU"
    // },
]

export const SellingStates = [
    {
        name: "Không",
        code: "NONE"
    },
    {
        name: "Thành công",
        code: "SUCCESS"
    },
    {
        name: "Thất bại",
        code: "FAILD"
    },
]

export const CustomerTypes = [
    {
        name: "Trả trước",
        code: "NORMAL"
    },
    {
        name: "Trả sau",
        code: "ASSIGNED"
    },
]

export const EMPTY_ID = "00000000-0000-0000-0000-000000000000";

export const InviteTypes = {
    GET_OTP: 'GET_OTP',
    CONFIRM_OTP: 'CONFIRM_OTP',
    GET_OTPnew: 'GET_OTPnew',
    CONFIRM_OTPnew: 'CONFIRM_OTPnew',
    GET_OTPnew1: 'GET_OTPnew1',
    CONFIRM_OTPnew1: 'CONFIRM_OTPnew1',
    GET_OTPnew2: 'GET_OTPnew2',
    CONFIRM_OTPnew2: 'CONFIRM_OTPnew2',
    RENEW: 'RENEW',
    IMMEDIATE: 'IMMEDIATE',
    SELLING: 'SELLING',
}

export const CONFIRM_TYPES = {
    DELETE: 'delete',
    LOCK: 'lock',
    UNLOCK: 'unlock'
}

export const NOTI_TYPES = {
    ERROR: 'error',
    SUCCESS: 'success'
}
export const ROW_PER_PAGE_OPTIONS = [20, 50, 100];

export const DEFAULT_ROW_PER_PAGE = 20;

export const DEFAULT_HOMEPAGE_ROW_PER_PAGE = 30;

export const DEFAULT_PAGE = 1

export const SIM_TYPE_LIST = [ 
    { 
        title: "Sim theo giá", 
        options: {
            "_price_0":"Dưới 500k",
            "_price_1":"500k - 1 triệu", 
            "_price_2":"1 - 2 triệu", 
            "_price_3":"2 - 3 triệu", 
            "_price_4":"3 - 5 triệu", 
            "_price_5":"5 - 10 triệu", 
            "_price_6":"10 - 50 triệu", 
            "_price_7":"50 - 100 triệu", 
            "_price_8":"Trên 100 triệu",
        },
    },

    { 
        title: "Sim theo mạng", 
        options: {
            "_operator_tra_truoc_mobifone":"Trả trước Mobifone",
            "_operator_tra_sau_mobifone":"Trả sau Mobifone",
            "_operator_tra_truoc_vinaphone":"Trả trước Vinaphone", 
            "_operator_tra_sau_vinaphone":"Trả sau Vinaphone", 
            "_operator_tra_truoc_viettel":"Trả trước Viettel",
            "_operator_tra_sau_viettel":"Trả sau Viettel",
        },
    },
    
    { 
        title: "Sim theo loại", 
        options: {
            "sim_loc_phat":"Sim Lộc Phát",
            "sim_than_tai":"Sim Thần Tài", 
            "sim_ong_dia":"Sim Ông Địa", 
            "sim_tam_hoa":"Sim Tam Hoa",  
            "sim_nam_sinh":"Sim Năm Sinh",
            "sim_luc_quy":"Sim Lục Quý", 
            "sim_ngu_quy":"Sim Ngũ Quý", 
            "sim_tu_quy":"Sim Tứ Quý",
            "tu_quy_giua":"Tứ Quý Giữa", 
            "sim_san_bang_tat_ca":"Sim San Bằng Tất Cả", 
            "sim_de_nho":"Sim Dễ Nhớ", 
            "sim_sanh_tien":"Sim Sảnh", 
            "sim_lap":"Sim Lặp Kép", 
            "sim_taxi":"Sim Taxi", 
            "sim_phong_thuy":"Sim Phong Thủy", 
            "sim_khuyen_mai":"Sim Khuyến Mãi", 
        },
    },
]

export const SIM_TYPE_LIST_OBJ = SIM_TYPE_LIST.reduce((stl, item) => {
    Object.entries(item.options).forEach(([key, value]) => {
        stl[key] = value;
    });
    return stl;
}, {});

export const SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR = SIM_TYPE_LIST.reduce((stl, item) => {
    Object.entries(item.options).forEach(([key, value]) => {
        if (item.title !== "Sim theo giá" && item.title !== "Sim theo mạng") {
            stl[key] = value;
        }
    });
    return stl;
}, {});

export const LOAI_GOI_CUOC = {
    "goi_hot":"Gói hot",
    "data":"Data", 
    "thoai_va_sms":"Thoại & SMS", 
}

export const OPERATOR_THEME = {
    mobifone: {
        primary: "#0073CF",      // Điểm sáng nhất từ gradient
        secondary: "#005BB5",    // Trung gian
        text: "#002B60",         // Tối hơn để đọc tốt
        bg: "#E6F0FA",           // Nền xanh nhạt
        border: "#004A99",       // Màu gradient cuối
    },
      vinaphone: {
        primary: "#00BDF2",      // Sáng nhất từ gradient
        secondary: "#009FE3",    // Trung gian
        text: "#005A8C",         // Tối vừa đủ
        bg: "#DFF7FF",           // Nền xanh nhạt dễ chịu
        border: "#0073CC",       // Màu gradient cuối
    },
    viettel: {
        primary: "#FF5A5A",     // đỏ tươi
        secondary: "#EE0434",   // đỏ trung bình
        text: "#7B001F",        // đỏ đậm (đọc dễ)
        bg: "#FFE9E9",          // nền hồng nhạt
        border: "#C7002E",      // viền đỏ đậm
    },
};

export const CU_PHAP_DANG_KY_GOI_CUOC = {
    mobifone: [
        {
            cu_phap: "D1 <TÊN_GÓI>",
            so_nhan: "9084",
        },
        {
            cu_phap: "DK <TÊN_GÓI> 0774144144",
            so_nhan: "9279",
        },
    ],
    vinaphone: [
        {
            cu_phap: "DL <TÊN_GÓI>",
            so_nhan: "1543",
        },
    ],
    viettel: [
        {
            cu_phap: "GC <TÊN_GÓI>",
            so_nhan: "290",
        },
    ],
};

export const POST_EDITOR_FONTS = [
    "Arial", 
    "Arial Black", 
    "Calibri", 
    "Cambria", 
    "Candara",
    "Century Gothic", 
    "Comic Sans MS", 
    "Consolas", 
    "Courier New", 
    "Georgia", 
    "Impact",
    "Lucida Console",
    "Lucida Sans Unicode",
    "Mulish",
    "Palatino Linotype",
    "Segoe UI", 
    "Tahoma", 
    "Times New Roman", 
    "Trebuchet MS", 
    "Verdana", 
    "Garamond",
    "Book Antiqua",
    "Courier", 
    "Monospace", 
    "Sans-serif", 
    "Serif"
];

export const POST_EDITOR_FONT_SIZES = [
    "8px", 
    "9px", 
    "10px", 
    "11px", 
    "12px", 
    "14px", 
    "16px", 
    "18px", 
    "20px", 
    "22px", 
    "24px", 
    "26px", 
    "28px", 
    "32px", 
    "36px", 
    "48px", 
    "72px"
];